export default {
  SET_BEDS (state, beds) {
    state.beds = beds
  },
  REMOVE_RECORD (state, itemId) {
    const bedIndex = state.beds.findIndex((u) => u.id === itemId)
    state.beds.splice(bedIndex, 1)
  }
}
